export enum Severity {
  unknown = 'unknown',
  low = 'low',
  normal = 'normal',
  high = 'high',
}

export const severityCompareFunction = (a: Severity | undefined, b: Severity | undefined): number => {
  if (a === b) return 0;
  if (a === Severity.high || (a === Severity.normal && b === Severity.low)) return -1;
  return 1;
};

export interface INote {
  type?: string;
  severity?: Severity;
  text?: string;
}
